var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('rdkm-title',[_vm._v("\n    "+_vm._s(_vm.$t('Обновления статусов у доноров'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }